import {Component, OnInit} from '@angular/core';
import {MatTab, MatTabGroup} from "@angular/material/tabs";
import {NgIf} from "@angular/common";
import {ActivatedRoute, RouterOutlet} from "@angular/router";
import {AgencyInProgressComponentComponent} from "./encour-component/agency-in-progress-component.component";
import {EstablishmentService} from "../../../services/establishment.service";
import {
  AgencyTerminatedMissionForEtabComponent
} from "./agency-terminated-mission-for-etab/agency-terminated-mission-for-etab.component";

@Component({
  selector: 'app-agency-etab-missions-details',
  standalone: true,
  imports: [
    MatTab,
    MatTabGroup,
    NgIf,
    RouterOutlet,
    AgencyInProgressComponentComponent,
    AgencyTerminatedMissionForEtabComponent
  ],
  templateUrl: './agency-etab-missions-details.component.html',
  styleUrl: './agency-etab-missions-details.component.scss'
})
export class AgencyEtabMissionsDetailsComponent implements OnInit {
  private id: any;
  public name: string;

  constructor(private api: EstablishmentService,
              private route: ActivatedRoute,
  ) {
    this.id = this.route.snapshot.params['establishmentId'] ?? 0;
  }

  ngOnInit(): void {
    if (this.id) {
      this.api.getEstablishmentNameById(this.id).subscribe({
        next: (response) => {
          this.name = response.name;
        },
        error: (err) => {
          console.error('Error fetching establishment name:', err);
          this.name = 'Unknown';
        }
      });
    }
  }

}
